import { useNavigate } from 'react-router-dom';
import personalInfo from './personalInfo';

export default function LandingPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-stone-50 flex flex-col items-center justify-center px-8">

      {/* Name + title block */}
      <div className="text-center mb-12">
        <h1 className="text-7xl sm:text-8xl font-extrabold tracking-tight text-stone-900 leading-none mb-4">
          {personalInfo.name}
        </h1>
        <hr className="rule w-24 mx-auto mb-4" />
        <p className="text-lg text-stone-400 font-light tracking-wide">
          {personalInfo.title}
        </p>
      </div>

      {/* Navigation buttons */}
      <nav className="flex flex-col sm:flex-row gap-4">
        <button
          onClick={() => navigate('/resume')}
          className="group px-10 py-4 border border-stone-900 text-stone-900 text-sm font-semibold tracking-widest uppercase hover:bg-stone-900 hover:text-stone-50 transition-colors duration-200"
        >
          Resume
        </button>
        <button
          onClick={() => navigate('/invoice')}
          className="group px-10 py-4 border border-stone-300 text-stone-500 text-sm font-semibold tracking-widest uppercase hover:border-stone-900 hover:text-stone-900 transition-colors duration-200"
        >
          Timesheet
        </button>
      </nav>

    </div>
  );
}
